(function($) {
    $.fn.iframeYouTubeTitleInjector = function() {
        this.each(function() {
            updateVideoTitle($(this));
        });
        return this;

        async function updateVideoTitle($iframe) {
            const
                iframeSrc = $iframe.attr('src'),
                regex = /^https:\/\/www.youtube.com\/embed\/([\w-]{11})/,
                matches = iframeSrc.match(regex);

            if (matches) {
                const
                    url = `https://www.youtube.com/oembed?url=${encodeURIComponent('https://www.youtube.com/watch?v=')}${matches[1]}&format=json`,
                    preamble = $().isWelshPage() ? 'Fideo Youtube' : 'YouTube Video';

                try {
                    const response = await fetch(url);

                    if (!response.ok) {
                        throw new Error(`Response status: ${response.status}`);
                    }

                    const json = await response.json(); // eslint-disable-line
                    $iframe.attr('title', `${preamble} - ${json.title}`);
                } catch (error) {
                    console.error(error.message);
                }
            }
        }
    };
}(jQuery));
